import { Alert } from 'avo-ui'
import { AwardCategory } from 'components/award/award-category/AwardCategory'
import { INIT_STATE, INITIAL_DATA_FILTER } from 'configs/award/configTableAwardCategory'
import { ACTION_TYPE } from 'constants/constant'
import { useValidation } from 'hooks/useValidation'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, getObjectName, setQueryParams } from 'utils/utils'

const OPTION_TYPE = [
    { label: 'Product', value: 'product' },
    { label: 'Brand', value: 'brand' },
]

export const AwardCategoryContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [awardCategoryDetail, setAwardCategoryDetail] = useState(INIT_STATE)
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getCategoryList, data: dataCategoryList, isLoading } = useFetch(API_AWARD.CATEGORY_LIST)
    const { fetching: createCategory, isLoading: isCreating } = useFetch(API_AWARD.CATEGORY_CREATE)
    const { fetching: updateCategory, isLoading: isUpdating } = useFetch(API_AWARD.CATEGORY_UPDATE)
    const { fetching: deleteCategory, isLoading: isDeleting } = useFetch(API_AWARD.CATEGORY_DELETE)
    const { isFormValid } = useValidation({ form: awardCategoryDetail })
    const [modal, setModal] = useState({
        delete: false,
        form: false,
    })

    useEffect(() => {
        fetchCategoryList(query)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchCategoryList = (item = { ...query }) => {
        getCategoryList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setAwardCategoryDetail({ ...awardCategoryDetail, [name]: value })
    }

    const onActionRow = ({ id, item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setAwardCategoryDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                const selectedType = OPTION_TYPE.find((itemType) => itemType.value === item.type)
                setAwardCategoryDetail({ ...item, type: selectedType })
                setShowModal({ form: true })
                break
            default:
                setAwardCategoryDetail(item)
                setShowModal({ delete: true })
        }
    }

    const onDelete = async () => {
        await deleteCategory({ category_ids: awardCategoryDetail?.id ? [awardCategoryDetail?.id] : selectedIds })
        setIsResetSelectedItem(!isResetSelectedItem)
        setShowAlert('Category Voting Deleted !', { delete: false })
        query?.page === '1' ? fetchCategoryList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
    }

    const onSubmit = async () => {
        const isUpdate = !!awardCategoryDetail.id
        const payload = {
            ...awardCategoryDetail,
            type: awardCategoryDetail.type.value,
        }
        if (isUpdate) {
            await updateCategory(payload, awardCategoryDetail.id)
            fetchCategoryList(query)
        } else {
            await createCategory(payload)
            query?.page === '1' ? fetchCategoryList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
        }
        setShowAlert(`Category Voting ${isUpdate ? 'Updated' : 'Created'}!`, { form: false })
    }

    const props = {
        dataList: dataCategoryList?.data,
        awardCategoryDetail,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        isFormValid,
        optionsType: OPTION_TYPE,
        selectedIds,
        setSelectedIds,
        onSelectItemHandler,
        onActionRow,
        onChangeForm,
        onHideForm,
        onSubmit,
        onDelete,
        isLoading,
        isDeleting,
        isCreating,
        isUpdating,
        isResetSelectedItem,
    }

    return <AwardCategory {...props} />
}
